/* Author: ahmadsisfo1@gmail.com */
import axios   from 'axios'
import tc      from '@/util/thencatch'
import st      from '@/util/localStorage'
import co      from '@/util/cookies'
import config  from '@/config'

let client =  axios.create({baseURL: config.rest, withCredentials: false,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});        

export default {    
    biz4 : {
        post : function(r, body = {}, params = {}, header = {}){                                   
            let headers = {Authorization: "Bearer " + this.key()};
            Object.assign(headers, header); 
            
            const config = {
                params : params,
                headers: headers                
            };            
            return tc(client.post(r, body, config));
        },
        
        get : function(r, params = {}){
            const config = {
                params : params,
                headers: { Authorization: "Bearer " + this.key() }
            };
            return tc(client.get(r, config));
        },
        
        setter : function(r){
            return {
                endpoint : config.rest + r,
                headers  : {Authorization: "Bearer " + this.key()}
            }
        },
        
        key : function(){
            var key = '';            
            if(co.get(config.prefix + 'key') !== null){
                key = co.get(config.prefix + 'key');
            } else if(st.get(config.prefix + 'key') !== null) {
                key = st.get(config.prefix + 'key');
            }            
            return key;
        },               
    },        
}
